import Devices from './device-types';

const WrongDevices = {
  [Devices.SMARTPHONE]: 'tablet or computer',
  [Devices.TABLET]: 'smartphone or computer',
  [Devices.COMPUTER]: 'smartphone or tablet',
};

export default WrongDevices;
